import type { ImportTemplateDefinition } from './importTemplates';

export function generateTemplateCsv(template: ImportTemplateDefinition): Blob {
  const allColumns = [...template.requiredColumns, ...template.optionalColumns];
  const header = allColumns.join(',');

  const rows = template.sampleRows.map(row => {
    return allColumns.map(col => {
      const value = row[col];
      if (value === undefined || value === null) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    }).join(',');
  });

  const csv = [header, ...rows].join('\n');
  return new Blob([csv], { type: 'text/csv;charset=utf-8;' });
}

export function downloadTemplateCsv(template: ImportTemplateDefinition): void {
  const blob = generateTemplateCsv(template);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${template.id}_template.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
